export const RAW_TRANSACTION_ACTIONS = [
  { key: 'purchase_inward', label: 'Purchase Inward', type: 'in' },
  { key: 'production_consumption', label: 'Production Consumption', type: 'out' },
  { key: 'manual_adjustment_plus', label: 'Manual Adjustment +', type: 'in' },
  { key: 'manual_adjustment_minus', label: 'Manual Adjustment -', type: 'out' }
];

export const RAW_TRANSACTION_ACTION_MAP = RAW_TRANSACTION_ACTIONS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

const LEGACY_TRANSACTION_FIELD_KEYS = new Set(['color_id', 'yarn_type_id', 'pad_type_id']);

export const isLegacyTransactionField = (field) => {
  const key = String(field?.key || '').trim().toLowerCase();
  const label = String(field?.label || '').trim().toLowerCase();
  if (LEGACY_TRANSACTION_FIELD_KEYS.has(key)) return true;
  if (key === 'color' || label === 'color') return true;
  return false;
};
